import styles from './DashboardItem.module.scss'
import { useState } from 'react';
import BarChartItem from '../Charts/BarChartItem';
import AreaChartItem from '../Charts/AreaChartItem';
import LineChartItem from '../Charts/LineChartItem';
import PieChartItem from '../Charts/PieChartItem';
import React from 'react';
import RingChartItem from '../Charts/RingChartItem';
export default function DashboardItem({data}){
  const [MVO] = useState(data);
  const targetValue = MVO.targetValue;
  const unit = MVO.unit;
  const length = MVO.datasource.data.length;
  const lastValue = MVO.datasource.data[length -1].value;
  return(
    <div className={styles.DashboardItemContainer}>
      <div className={styles.header}>
        <h3>{MVO.name}</h3>
        <img width="10%" height="10%" src={MVO.icon} alt="sdg"/>
      </div>
      {(()=> {
              switch(MVO.chartType){
                case "bar":
                  return <BarChartItem data={MVO.datasource.data}/>
                case "area":
                  return <AreaChartItem data={MVO.datasource.data}/>
                case "line":
                  return (
                      <LineChartItem data={MVO.datasource.data} unit={unit} lastValue={lastValue}/>
                  )
                case "pie":
                  return <PieChartItem data={MVO.datasource.data}/>
                case "ring":
                  return <div className={styles.chartContainer}><RingChartItem value={lastValue} unit={unit} targetValue={targetValue}/>
                  <p>{lastValue} / {targetValue} <br/> {unit}</p>
                    </div>
                default:
                  return null;
  
              }
      })()
      }
    </div>
  );
}